import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import PSLoading from './PSLoading';

const StyledButton = styled.button`
  background-color: #ed6e00;
  font-size: 20px;
  border-radius: 8px;
  cursor:pointer;
  color: #ffffff;
  text-align: center;
  width: 100%;
  height: 42px;
  border: none;
  outline: none;
  font-family: 'Gotham-Medium' , sans-serif;
  
  &:disabled {
    opacity: .8;
    cursor: not-allowed ;
  }
`;

const PSButton = React.forwardRef(({ children, loading, ...props }, ref) => (
  <StyledButton {...props} ref={ref} disabled={loading}>
    {loading ? <PSLoading width={25} height={25} /> : children}
  </StyledButton>
));

PSButton.displayName = 'PSButton';

PSButton.defaultProps = {
  onClick: () => {},
  className: null,
  loading: false,
};

PSButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.elementType.isRequired,
  loading: PropTypes.bool,
};

export default PSButton;
